import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=96496598&scoped=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteUserModal.vue?vue&type=style&index=0&id=96496598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96496598",
  null
  
)

export default component.exports